var _rect, _circle, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#2D2F3A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.9996,
    cy: 10.4996,
    r: 4.2,
    stroke: "#737687",
    strokeWidth: 1.4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_221_33",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.7002 21.7008C7.7002 18.9946 9.894 16.8008 12.6002 16.8008H15.4002C18.1064 16.8008 20.3002 18.9946 20.3002 21.7008V23.1008H7.7002V21.7008Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3002 21.7008C6.3002 18.2214 9.1208 15.4008 12.6002 15.4008H15.4002C18.8796 15.4008 21.7002 18.2214 21.7002 21.7008L18.9002 21.7008C18.9002 19.7678 17.3332 18.2008 15.4002 18.2008H12.6002C10.6672 18.2008 9.1002 19.7678 9.1002 21.7008L6.3002 21.7008ZM20.3002 23.1008H7.7002H20.3002ZM6.3002 23.1008V21.7008C6.3002 18.2214 9.1208 15.4008 12.6002 15.4008L12.6002 18.2008C10.6672 18.2008 9.1002 19.7678 9.1002 21.7008V23.1008H6.3002ZM15.4002 15.4008C18.8796 15.4008 21.7002 18.2214 21.7002 21.7008V23.1008H18.9002V21.7008C18.9002 19.7678 17.3332 18.2008 15.4002 18.2008L15.4002 15.4008Z",
    fill: "#737687",
    mask: "url(#path-3-inside-1_221_33)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.72a45652354e9a9620cf86f1e7de2d15.svg";
export { ForwardRef as ReactComponent };